<template>
  <main
    :class="{
      'main-content-area': true,
      'custom-background-image': $root.color_schema.site_bg_img,
    }"
    :style="{
      '--bg-image': `url(${$root.color_schema.site_bg_img}) repeat`,
      '--bg-color': $root.color_schema.site_bg_color,
    }"
  >
    <a
      class="main-tag cas-link"
      :href="getGoLink($root.goto_link, $root.slug)"
      v-if="$root.color_schema.site_bg_img"
      target="_blank"
      :rel="$root.change_cta_to_sponsored ? 'nofollow sponsored' : 'nofollow'"
    ></a>
    <div
      :class="{
        'custom-background-color': $root.color_schema.site_bg_img,
        'page-wrapper pb-25': true,
        'pt-26': mapBlock ? false : true,
      }"
      v-observer="mutationObserveDefault"
    >
      <!-- Game banner section -->
      <section
        :class="{ 'ct-article': true, 'pt-26': mapBlock ? true : false }"
        :style="{
          'background-color': mapBlock ? $root.color_schema.primary : null,
        }"
      >
        <div class="container">
          <!--Breadcrumps-->
          <div class="col-md-12">
            <Breadcrumb
              :breadcrumbData="mapTemplateData.breadcrumb"
              :dark="
                mapBlock ? getContrastYIQ($root.color_schema.primary) : true
              "
            />
          </div>
          <!--End Breadcrumps-->
        </div>
      </section>
      <!-- End Game banner section -->
      <!-- Horizontal Cards -->
      <template v-for="(data, index) in blockData">
        <template v-if="data.blockName === 'wpvcb/us-map-data' && data.filtered_content">
          <USMap :key="`${data.blockName}-${index}`"
            :usmapData="data.filtered_content"
            :heightVal="mapBlock ? false : true"/>
        </template>
				<CustomComponent :key="`${data.blockName}-${index}`" 
					:blockData="data" 
					:recommendSection="data.blockName === 'wpvcb/casino-toplist' && !data.attrs.style ? recommend_section : {}"
					:bluebar="data.blockName === 'wpvcb/casino-toplist' && (!data.attrs.style || data.attrs.style === 'ab_test_style') ? bluebar : {}"
          :blockIndex="index"
          />
			</template>
      <!-- Horizontal Cards ends -->

      <!--Related Page Links-->
      <template
        v-if="
          morePaymentBottom &&
          blockData.length === mapTemplateData.content.blocks.length
        "
      >
        <RelatedLinks :relatedLinkData="morePaymentBottom" />
      </template>
      <!--End Related Page Links-->

      <!--Author Block-->
      <template
        v-if="
          auhtorBlockdata &&
          blockData.length === mapTemplateData.content.blocks.length
        "
      >
      </template>
      <!--End Author Block-->
    </div>
  </main>
</template>

<script>
import Breadcrumb from "@/components/layouts/Breadcrumb";
import USMap from "@/components/custom-block/USMap";
import CustomComponent from '@/components/CustomComponent';
import RelatedLinks from "@/components/custom-block/RelatedLinks";

import { metaChanger } from "@/misc/meta-changer";
import { pSBC, getContrastYIQ, getOffset } from "@/misc/misc-function";

export default {
  name: "MapTemplate",
  props: ["mapTemplateData"],
  data() {
    return {
      top_block: {
        type: Object,
        default: () => {},
      },
      assets_images: {
        type: Object,
        default: () => {},
      },
      morePaymentBottom: {
        type: Object,
        default: () => {},
      },
      embedBlockNameList: [
        "core-embed/facebook",
        "core-embed/twitter",
        "core-embed/instagram",
        "core-embed/tumblr",
        "core-embed/tiktok",
      ],
      blockData: [],
      blockDataIndex: 0,
      busy: false,
      mapBlock: false,
      scriptFlag: 0,
      auhtorBlockdata: [],
      rightBlockdata: [],
      bluebar: {},
    };
  },
  components: {
    Breadcrumb,
    CustomComponent,
    USMap,
    RelatedLinks,
  },
  created: function () {
    if (
      this.$root.routes_meta[this.$route.params.postSlug] &&
      this.$root.routes_meta[this.$route.params.postSlug].metaTags
    )
      this.metaChanger(
        this.$root.routes_meta[this.$route.params.postSlug].metaTags
      );

    // Schema Append
    document.getElementById("schema-script").innerHTML =
      this.mapTemplateData.schema;

    // Blocks Filtered
    let title = this.mapTemplateData.content.blocks.filter((ele) => {
      if (ele.blockName === "core/heading") {
        return ele.filtered_content;
      }
    });
    let content = this.mapTemplateData.content.blocks.filter((ele) => {
      if (ele.blockName === "core/paragraph") {
        return ele.filtered_content;
      }
    });
    let emoji_section = this.mapTemplateData.content.blocks.filter((ele) => {
      if (ele.blockName === "core/html") {
        return ele.filtered_content;
      }
    });
    this.top_block = { title, content, emoji_section };

    // More Payments Bottom Card
    this.morePaymentBottom = this.mapTemplateData.meta.more_payment_method;

    // Author Blocks Filtered
    let atBlock = this.mapTemplateData.content.blocks.filter((ele) => {
      if (ele.blockName === "wpvcb/author-block") {
        return ele.filtered_content;
      }
    });
    if (atBlock.length > 0)
      this.auhtorBlockdata = atBlock.shift().filtered_content;

    // RightContent Blocks Filtered
    let rightBlock = this.mapTemplateData.content.blocks.filter((ele) => {
      if (ele.blockName === "wpvcb/right-content-simpletoc") {
        return ele.filtered_content;
      }
    });
    if (rightBlock.length > 0)
      this.rightBlockdata = rightBlock.shift().filtered_content;

    // Adminbar Data
    this.$root.adminBarData =
      Object.keys(this.mapTemplateData.toolbar).length > 0
        ? this.mapTemplateData.toolbar
        : "";
    this.$root.disable = this.$root.adminBarData
      ? this.$root.adminBarData.visible
      : false;

    // Assets Sizes
    this.assets_images =
      Object.keys(this.$root.asset_sizes).length > 0
        ? this.$root.asset_sizes
        : "";
  },
  mounted: function () {
    // if (this.$root.enable_lazyload) {
    //   this.incrementBlockDataValue();
    //   this.$root.show_footer = false;
    // } else {
    this.blockData = this.mapTemplateData.content.blocks;
    this.$root.show_footer = true;
    //}

    if (
      this.scriptFlag === 0 &&
      this.mapTemplateData.content.blocks.filter((ele) => {
        return (
          ele.blockName === "wpvcb/custom-youtube" ||
          ele.blockName === "wpvcb/youtube-film-strip"
        );
      }).length > 0
    ) {
      this.youtubeInit();
      this.scriptFlag++;
    }

    let _arrmap = [];
    _arrmap = this.mapTemplateData.content.blocks.filter(
      (ele, index) => ele.blockName === "wpvcb/us-map-data" && index === 0
    );

    if (_arrmap.length > 0) this.mapBlock = true;

    this.$nextTick(() => this.heightCheck());
    var that = this;
    window.addEventListener(
      "scroll",
      () => {
        that.heightCheck();
      },
      { passive: true }
    );
    window.addEventListener("resize", () => {
      that.heightCheck();
    });
  },
  beforeDestroy: function () {
    window.removeEventListener(
      "scroll",
      () => {
        that.heightCheck();
      },
      { passive: true }
    );
    window.removeEventListener("resize", () => {
      that.heightCheck();
    });
  },
  methods: {
    pSBC,
    getContrastYIQ,
    getOffset,
    metaChanger,
    heightCheck: function () {
      let appDOM = document.getElementById("app");
      let windowHeight = window.innerHeight;
      let appBottom = appDOM.scrollHeight - windowHeight - window.pageYOffset;
      if (appBottom < windowHeight / 2) {
        this.loadMore();
      }
    },
    // Infinite scroll Height Checking
    mutationObserveDefault: function (mutations) {
      if (this.blockData.length < this.mapTemplateData.content.blocks.length) {
        let mainContentArea =
          this.getOffset(mutations[0].target).top +
          mutations[0].target.offsetHeight;
        if (mainContentArea < window.innerHeight) {
          this.incrementBlockDataValue();
          this.heightCheck();
        }
      }
    },
    // Infinite scroll load more
    loadMore: function () {
      if (this.blockData.length < this.mapTemplateData.content.blocks.length) {
        this.busy = true;
        this.incrementBlockDataValue();
        //this.heightCheck();
        this.busy = false;
      }
    },
    incrementBlockDataValue: function () {
      this.blockData = this.mapTemplateData.content.blocks.slice(
        0,
        this.blockDataIndex + 1
      );
      this.blockDataIndex++;
    },
    itemFAQ: function (data) {
      let FAQitems = [];
      data.forEach((ele) => {
        let { id, faq_question: title, faq_answer: content } = ele;

        let is_active = false;
        if (ele.is_active === "1") {
          is_active = true;
        }

        FAQitems.push({ id, title, content, is_active });
      });
      return FAQitems;
    },
  },
  watch: {
    blockData: function () {
      if (
        this.blockData.length === this.mapTemplateData.content.blocks.length
      ) {
        this.$root.show_footer = true;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/base/variable";

.ct-article {
  padding-bottom: 15px;
  h1 {
    margin: 0 !important;
  }
}

.ct-card-horizontal {
  padding: 0;
}

.casino-header {
  display: table;
  width: 100%;
  background: @darkblue;
  .border-radius(12px);
  h2 {
    text-align: center;
    color: @white;
    font-weight: bold;
    padding: 8px;
  }
  &-home {
    .display-flex();
    .align-items(center);
    .justify-content-space-between();
    padding: 10px 0;
    .casino-inner {
      color: @white;
      text-align: center;
      padding: 0px 20px;
      border-right: 1px solid @white;
      -webkit-box-flex: 1;
      -ms-flex: 1 0 0px;
      flex: 1 0 0;
      display: none;
      &:last-child {
        border-right: 0;
        display: block;
      }
      h2 {
        color: @white;
        border-right: 0;
        font-weight: bold;
        padding: 0 8px;
      }
      img {
        vertical-align: top;
        margin-right: 8px;
        margin-top: 3px;
      }
      @media (min-width: @sizes[medium]) {
        display: block;
      }
    }
  }
}

.progressive-content-box {
  margin: 0 !important;
}

.ct-editor-section {
  padding: 7px 0;
}

.pt-20 {
  padding-top: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/MapTemplate.vue